/**
 * Validates that a URL uses a safe protocol (http or https).
 * Blocks javascript:, data:, vbscript:, and other dangerous schemes.
 */
export function isSafeUrl(url: string): boolean {
  if (!url || typeof url !== 'string') return false;
  try {
    const parsed = new URL(
      url,
      typeof window !== 'undefined' ? window.location.origin : 'https://placeholder.invalid'
    );
    return parsed.protocol === 'https:' || parsed.protocol === 'http:';
  } catch {
    return false;
  }
}
